import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Flag } from "lucide-react";
import { AdInterests } from "@/components/AdInterests";

// Skippable "pick a few interests" step shown right after a member claims their
// BR License. Never gates anything - Save or Skip both continue to `next`.
export default function InterestOnboarding() {
  const [sp] = useSearchParams();
  const navigate = useNavigate();
  const next = sp.get("next") || "/calendar";
  const go = () => {
    try { localStorage.setItem("tr_interests_onboarded", "1"); } catch (e) { /* ignore */ }
    navigate(next);
  };
  return (
    <div className="max-w-lg mx-auto animate-slide-up" data-testid="interest-onboarding">
      <div className="flex items-center gap-2 text-race-red mb-2">
        <Flag size={16} /><span className="overline">You're licensed to race</span>
      </div>
      <h1 className="font-heading text-4xl sm:text-5xl tracking-tight">Pick a few interests</h1>
      <p className="text-race-sub mt-2 text-sm">
        Optional - this just helps us show sponsors you actually care about. You can change these
        any time in your profile, and you can skip it entirely.
      </p>

      <div className="mt-6">
        <AdInterests onboarding />
      </div>

      <div className="flex items-center gap-3 mt-6">
        <button onClick={go} data-testid="onboarding-continue"
          className="flex-1 bg-race-volt text-race-bg font-heading text-2xl tracking-wide py-3 rounded-sm hover:opacity-90 transition-opacity">
          CONTINUE →
        </button>
        <button onClick={go} data-testid="onboarding-skip"
          className="border border-race-line text-race-sub hover:text-race-txt px-5 py-3 rounded-sm text-sm font-mono uppercase tracking-wide transition-colors">
          Skip
        </button>
      </div>
    </div>
  );
}
